import styled from "styled-components";

export const Cont=styled.div`
    
    //border:2px solid white;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    gap:10px;
    margin-bottom:10px;

`

export const FormH1=styled.h1`
    
  margin-bottom: 60px;
  color: #fff;
  font-size: 30px;
  font-weight: 500;
  text-align: center; 
`
export const User=styled.label`
    margin-bottom:8px;
    top:2;
    left:4;
    display:block;
    postion:relative;
    font-size:14px;
    color:#fff;
    position:relative;
`
export const UserInp=styled.input`
    width:148px;
    height:40px;
    padding:16px 16px;
    font-size:10px;
    margin-bottom:8px;
    boder:none;
    border-radius:4px;
`

export const State=styled.label`
    margin-bottom:4px;
    font-size:14px;
    color:#fff;
`
export const Connt=styled.div`
    
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;


`
